const toStringId = (id) => (id._id || id).toString();
function getDateOnly(date, timeZone) {
  const DateOnly = require('dateonly');
  const moment = require('moment-timezone');
  date = timeZone ? moment(date).tz(timeZone).utc(true).toDate() : date;
  return new DateOnly(date);
}
function toInt(date) {
  return getDateOnly(date).valueOf();
}
const checkDiscount = (discount, name, checkIds) => {
  const conditionIds = (discount.conditions[name] || []).map(toStringId);

  if (!checkIds || !conditionIds.length) return 0;

  const checkIdList = Array.isArray(checkIds) ? checkIds.map(toStringId) : [toStringId(checkIds)];
  return checkIdList.some((id) => conditionIds.includes(id)) ? 1 : 0;
};

const isDateValid = (conditions) => {
  const currentDate = toInt(new Date());
  const startDate = conditions && conditions.startDate ? parseInt(conditions.startDate) : null;
  const expiryDate = conditions && conditions.expiryDate ? parseInt(conditions.expiryDate) : null;

  return !(startDate && currentDate < startDate) && !(expiryDate && currentDate > expiryDate);
};

const evaluateConditions = (discount, product, user) => {
  if (!isDateValid(discount.conditions)) {
    return 0; // Discount is not active
  }
  if (discount.type === 'Redemptions') {
    return 0;
  }

  const conditions = [
    { name: 'bySupplier', checkIds: product.supplierId },
    user && user._id && { name: 'byCustomer', checkIds: user._id },
    user && user._id && { name: 'byStoreRoles', checkIds: user.roles },
    { name: 'byCategory', checkIds: [...(product.categories || []), ...(product.parentCategories || [])] },
    { name: 'byFacet', checkIds: product.facets },
    { name: 'byProduct', checkIds: product._id },
  ].filter((e) => {
    return e && discount && discount.conditions && discount.conditions[e.name] && discount.conditions[e.name].length;
  });

  if (!conditions.length) return 0;

  const allConditionsMet = conditions.every(({ name, checkIds }) => checkDiscount(discount, name, checkIds) > 0);

  return allConditionsMet ? 1 : 0;
};

const calculateProductDiscount = (product, data, user) => {
  const discountRatings = data.reduce((acc, discount) => {
    const rating = evaluateConditions(discount, product, user);
    if (rating > 0) acc[discount._id] = discount.flatAmountOrPercent;
    return acc;
  }, {});

  const bestDiscountId = Object.keys(discountRatings).sort((a, b) => discountRatings[b] - discountRatings[a])[0];
  const bestDiscount = data.find((d) => d._id.toString() === bestDiscountId);

  return {
    data: bestDiscount,
    percent: bestDiscount ? bestDiscount.flatAmountOrPercent / 100 : 0,
  };
};

const calculateFundraisingAmount = (price, data) => {
  if (
    !isDateValid({
      startDate: data.startDate,
      expiryDate: data.expiryDate,
    })
  ) {
    return price;
  }
  let amount = price;
  const amountPerItem = data.amountPerItem || 0;
  const percentagePerItem = data.percentagePerItem || 0;
  if (amountPerItem && percentagePerItem) {
    amount = price + amountPerItem + (price * percentagePerItem) / 100;
  } else if (amountPerItem) {
    amount = price + amountPerItem;
  } else if (percentagePerItem) {
    amount = price + (price * percentagePerItem) / 100;
  }

  return amount.roundCeil();
};

module.exports = {
  methods: {
    storeProductDiscount(product, store, user) {
      if (!store || !Array.isArray(store.discounts)) return 0;
      const discount = calculateProductDiscount(product, store.discounts, user);

      return discount.percent;
    },
    storeProductSpecial(product, specialData, user) {
      if (!specialData.length) return 0;
      const special = calculateProductDiscount(product, specialData, user);

      return special.data;
    },
    storeProductFundraisingAmount(price, store) {
      if (!store || !store.fundraising) {
        return price;
      }
      const { fundraising } = store;
      const amountPerItem = fundraising.amountPerItem || 0;
      const percentagePerItem = fundraising.percentagePerItem || 0;
      if (!amountPerItem && !percentagePerItem) {
        return price;
      }

      const data = {
        ...fundraising,
        startDate: fundraising.startDate || null,
        expiryDate: fundraising.expiryDate || null,
      };

      return calculateFundraisingAmount(price, data);
    },
  },
};
